import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Modal, ModalHeader, ModalBody, FormFeedback, Button, FormGroup, Label, Input, Row, Col, Spinner } from "reactstrap";
import axios from "axios";
import cookies from "js-cookie";
import moment from "moment";
import jwtDecode from "jwt-decode";

import * as actionTypes from "./../../store/actions/actionTypes";
import Form from "../../components/general/Form/Form";
import logo from "../../assets/icons/new/aom-primary-logo-1.png";

import classes from './LoginPage.module.scss';

const config = {
  headers: {
    "Content-Type": "application/json"
  }
};

const initialState = {
  email: null,
  password: null,
  validEmailInput: true,
  validPasswordInput: true,
  loginSuccess: true,
  isLoading: false
};

class AomLoginPage extends Component {
  state = initialState;

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    if (this.state.email && this.state.password) {
      let userData = {
        email: this.state.email,
        password: this.state.password
      };
      try {
        this.setState({
          isLoading: true
        })
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/user/login`, userData, config);
        if (res.status === 200) {
          let token = res.data.token;
          const has_accepted_terms_and_conditions = res.data.has_accepted_terms_and_conditions;

          // store jwt in cookie for 30 minutes
          if (cookies.get("token")) {
            cookies.remove("token");
          }
          cookies.set("token", token, { expires: moment().add(90, "minutes").toDate() });
          // set user state in app store
          token = jwtDecode(token);
          this.props.setUser(token.id, token.user);

          localStorage.setItem("name", JSON.stringify(token.user));
          localStorage.setItem("userId", JSON.stringify(token.id));
          localStorage.setItem("role", JSON.stringify(token.role));
          localStorage.setItem("has_accepted_terms_and_conditions", JSON.stringify(has_accepted_terms_and_conditions));


          // redirect to page login page was called from if it exists
          let calledFrom = this.props.location && this.props.location.state ? this.props.location.state.calledFrom : null;
          this.setState({
            isLoading: false
          })
          this.props.history.push(calledFrom ? calledFrom : token.role === 4 ? "/dashboard/map" : "/dashboard/admin/advertise");
          return;
        }
      } catch (err) {
        this.setState({
          isLoading: false
        })
        console.log(err);
      }
      this.setState({
        loginSuccess: false
      });
    } else {
      let validEmail = this.state.email ? true : false;
      let validPassword = this.state.password ? true : false;
      this.setState({
        validEmailInput: validEmail,
        validPasswordInput: validPassword
      });
    }
  };

  emailChangeHandler = (e) => {
    this.setState({
      email: e.target.value
    });
  };

  passwordChangeHandler = (e) => {
    this.setState({
      password: e.target.value
    });
  };

  render() {
    const formStyle = {
      boxShadow: "none",
      padding: 10
    };
    const logoStyle = {
      width: "100%"
    };
    const buttonStyle = {
      width: "100%",
      backgroundColor: "#00b249"
    };
    let error = this.state.loginSuccess ? null : (
      <Col xs="12">
        <FormGroup>
          <Label className="text-danger">Invalid email/password</Label>
        </FormGroup>
      </Col>
    );
    return (
      <Fragment>
        <Helmet>
          <title>Boxi | Log In</title>
        </Helmet>
        <div className={classes.aomLoginPageWrapper}>
          <Row>
            <Col xs="10" sm="8" md="6" lg="4" xl="3" className={classes.loginCard} style={{ margin: "0 auto" }}>
              <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
                <Row form className="mb-5 pl-4 pr-4">
                  <Col>
                    <img src={logo} style={logoStyle} />
                  </Col>
                </Row>
                <Row form className="pl-4 pr-4">
                  <Col xs="12">
                    <FormGroup>
                      <Input
                        type="email"
                        onChange={this.emailChangeHandler}
                        value={this.state.email ? this.state.email : ""}
                        invalid={!this.state.validEmailInput}
                        placeholder="Email"
                      />
                      <FormFeedback>An email must be provided</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row form className="mb-4 pl-4 pr-4">
                  <Col xs="12">
                    <FormGroup>
                      <Input
                        type="password"
                        onChange={this.passwordChangeHandler}
                        value={this.state.password ? this.state.password : ""}
                        invalid={!this.state.validPasswordInput}
                        placeholder="Password"
                      />
                      <FormFeedback>A password must be provided</FormFeedback>
                    </FormGroup>
                  </Col>
                  {error}
                </Row>
                <Row form className="mb-4 pl-4 pr-4">
                  <Col xs="12">
                    <Button type="submit" onClick={this.onFormSubmitHandler} className="btn-aom-primary" style={buttonStyle}>
                      {this.state.isLoading ? 
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <Spinner
                              style={{ width: "1.2rem", height: "1.2rem" }}
                              type="border"
                              color="light"
                              className="spinner-border-sm"
                            />
                        </div>
                      :
                        <span>Log In</span>
                      }
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (id, name) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        user: {
          id: id,
          name: name
        }
      });
    }
  };
};

export default connect(null, mapDispatchToProps)(withRouter(AomLoginPage));